import qs from 'qs';
import { DateTime, usaDateFormat } from 'common/utils/date';

// Warning! Move this to webpack, modularize, and test this ASAP
var DateRangeQueryString = window.DateRangeQueryString || {};
window.DateRangeQueryString = DateRangeQueryString;

DateRangeQueryString.dateRange = function () {
  var params = this._params();

  var defaultTimestamp =
    window.initializationData &&
    window.initializationData.metricDateFilterConfigs &&
    window.initializationData.metricDateFilterConfigs
      .solicitation_reporting_timestamp;

  return {
    start: this._paramsStartDate(params),
    end: this._paramsEndDate(params),
    solicitation_reporting_timestamp:
      params.solicitation_reporting_timestamp ||
      defaultTimestamp ||
      'created_at',
  };
};

DateRangeQueryString.setDateRange = function (range, format) {
  if (range.start && range.end) {
    var params = this._params();

    params.start_date = range.start.toFormat(format);
    params.end_date = range.end.toFormat(format);

    if (range.solicitation_reporting_timestamp) {
      params.solicitation_reporting_timestamp =
        range.solicitation_reporting_timestamp;
    }

    window.history.replaceState(
      {},
      '',
      window.location.pathname +
        qs.stringify(params, { addQueryPrefix: true, encode: false })
    );
  }
};

DateRangeQueryString.setQuestion = function (questionId) {
  if (questionId) {
    var params = this._params();

    params.question = questionId;

    window.history.replaceState(
      {},
      '',
      window.location.pathname +
        qs.stringify(params, { addQueryPrefix: true, encode: false })
    );
  }
};

// Private functions
DateRangeQueryString._params = function () {
  return qs.parse(window.location.search, { ignoreQueryPrefix: true });
};

DateRangeQueryString._paramsStartDate = function (params) {
  var startDate = params.start_date;
  if (window.Localize) {
    DateTime.now().setLocale(window.Localize.getLanguage());
  } else {
    DateTime.now().setLocale('en');
  }
  // using new Date() because the start date received has different format for
  // service recovery and trends team page.
  return startDate ? DateTime.fromJSDate(new Date(startDate)) : null;
};

DateRangeQueryString._paramsEndDate = function (params) {
  var endDate = params.end_date;
  if (window.Localize) {
    DateTime.now().setLocale(window.Localize.getLanguage());
  } else {
    DateTime.now().setLocale('en');
  }
  return endDate ? DateTime.fromJSDate(new Date(endDate)) : null;
};
